import React from "react";
import styles from "./Avatar.module.css";
import { resolveUploadUrl } from "../../utils/apiClient";

function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  const initials = parts.map((p) => p[0]?.toUpperCase() || "").join("");
  return initials || "?";
}

export default function Avatar({
  name,
  imageUrl,
  size = "sm",
  variant = "default",
  alt,
}) {
  const sizeClass =
    size === "lg" ? styles.sizeLg : size === "md" ? styles.sizeMd : styles.sizeSm;
  const variantClass = variant === "contractor" ? styles.contractor : "";
  const className = [styles.avatar, sizeClass, variantClass]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className} aria-hidden={!alt}>
      {imageUrl ? (
        <img src={resolveUploadUrl(imageUrl)} alt={alt || name || ""} />
      ) : (
        <span>{getInitials(name)}</span>
      )}
    </div>
  );
}
